<template>
	<div>
		<v-card-title class="mb-3">
			<h2 style="padding-left: 10px">Konkursy departamentu</h2>
		</v-card-title>
		<PublicContestDepartmentDataTable ref="contestTable" v-model="dataTable"/>
        <v-card-title class="mb-3">
			<h2 style="padding-left: 10px">Pracownicy departamentu</h2>
		</v-card-title>
        <UsersDepartmentDataTable></UsersDepartmentDataTable>
	</div>
</template>

<script>

	import {Api} from "@/api";
	import PublicContestDepartmentDataTable from "./PublicContestDepartmentDataTable";
    import UsersDepartmentDataTable from "./UsersDepartmentDataTable";

	export default {
		name: "ContestListView",
		components: {
			PublicContestDepartmentDataTable, UsersDepartmentDataTable
		},


		watch: {
			dialog(val) {
				if (!val) {
					this.vErrors.clear();
				} else {
					Api.get(this, "/department/list", response => {
						this.departments = response;
					});
				}
			},
		},

		mounted () {
			this.removeEmptyTableLoading();
		},

		methods: {
			save() {
				if (!this.$refs.form.validate()) {
					return;
				}
				Api.post(this, "/public-contest", this.newItem, () => {
						// wywołanie przeładowania konkursów (metoda komponentu)
						this.$refs.contestTable.getItemList();
						this.dialog = false;
						this.clearDialog();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, this.snackbarMessage + " " + JSON.stringify(errorResponse));
					});

			},

			cancel() {
				this.dialog = false;
				this.clearDialog();
			},

			clearDialog() {
				this.newItem.name = "";
				this.newItem.shortName = "";
				this.newItem.departmentId = null;
			},

			removeEmptyTableLoading () {
				var el = document.querySelector(".v-datatable__progress");
				el.parentNode.removeChild(el);
			},

		},

		data() {
			return {

				dataTable: {
					searchFields: {},
					tableHeaders: [
						{text: "", value: "termExpirationStatus", sortable: false},
						{text: "Nazwa konkursu", value: "contestName", sortable: true},
						{text: "Koniec naboru ofert", value: "endDate", sortable: true},
						{text: "Departament", value: "departmentName", sortable: true},
						{text: "Akcje", value: "action", sortable: false},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
						sortBy: "",
					},
					search: "",
				},
				departments: [],
				dialog: false,

				newItem: {
					name: "",
					shortName: "",
					departmentId: null,
					valid: true,
				},

				validationRules: [
					v => !!v || "To pole jest wymagane",
				],
			};
		},
	};
</script>

<style scoped>

</style>
